import { useEffect, useState } from "react";
import { api } from "../lib/apiClient";
import { toast } from "sonner";

const DAYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

export const WeeklySchedule = ({ guildId, isPro }) => {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get(`/guilds/${guildId}/weekly-report/schedule`).then(r => setS(r.data.schedule)).catch(() => {});
  }, [guildId]);

  const save = async (patch) => {
    const next = { ...s, ...patch };
    try {
      const r = await api.put(`/guilds/${guildId}/weekly-report/schedule`, { enabled: next.enabled, day: next.day, hour: Number(next.hour) });
      setS(r.data.schedule);
      toast.success(next.enabled ? `Weekly report scheduled · ${next.day.toUpperCase()} ${String(next.hour).padStart(2, "0")}:00 UTC` : ("enabled" in patch ? "Automatic weekly report off" : "Schedule saved"));
    } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
  };

  if (!s) return null;
  const sel = "bg-[#06070A] border border-white/10 px-2 py-1.5 text-xs font-mono outline-none focus:border-[#F59E0B]";
  return (
    <div className="flex flex-wrap items-center gap-3 mb-4 border border-white/5 bg-[#06070A]/60 p-3" data-testid="weekly-schedule">
      <button
        data-testid="weekly-schedule-toggle"
        disabled={!isPro}
        onClick={() => save({ enabled: !s.enabled })}
        className={`px-3 py-1.5 font-mono text-[10px] tracking-widest border transition-colors ${s.enabled ? "border-[#10B981] text-[#10B981] bg-[#10B981]/10" : "border-white/10 text-[#64748B] hover:text-white"}`}
      >
        AUTO-SEND {s.enabled ? "ON" : "OFF"}
      </button>
      <span className="font-mono text-[10px] text-[#64748B]">every</span>
      <select data-testid="weekly-schedule-day" disabled={!isPro} value={s.day} onChange={e => save({ day: e.target.value })} className={sel}>
        {DAYS.map(d => <option key={d} value={d}>{d.toUpperCase()}</option>)}
      </select>
      <span className="font-mono text-[10px] text-[#64748B]">at</span>
      <select data-testid="weekly-schedule-hour" disabled={!isPro} value={s.hour} onChange={e => save({ hour: Number(e.target.value) })} className={sel}>
        {Array.from({ length: 24 }, (_, h) => <option key={h} value={h}>{String(h).padStart(2, "0")}:00 UTC</option>)}
      </select>
      {s.last_sent_at && <span className="ml-auto font-mono text-[10px] text-[#64748B]" data-testid="weekly-last-sent">last sent {new Date(s.last_sent_at).toLocaleString()}</span>}
    </div>
  );
};
